 <template>
    <a :href="`mailto:${formattedEmail}`" target='_blank'>
        <span>{{ formattedEmail }}</span>
    </a>
</template>
<script>
import {defineComponent} from 'vue';

export default defineComponent({
  props: {
    email: String,
  },

  computed: {
    formattedEmail() {
      return this.email?.toLowerCase();
    },
  },
});
</script>
